import axios from "axios";

//export default axios.create({baseURL: 'http://lnv-3226.sb.dfki.de:8080/', headers: {
//export default axios.create({baseURL: 'http://localhost:8080/', headers: {
export default axios.create({baseURL: 'https://www.dfki.de/', headers: {
        'Content-Type': 'text/plain',
    'Accept': 'application/json'
}});
